// The page of the site someone opened the checkout from: the driver's license
// page, a university's requirements, a blog post. The static pages are plain
// HTML, so their order and quote buttons load the app afresh and the browser
// passes that page as the referrer. Kept for the visit (sessionStorage) and
// sent with the abandoned-checkout lead (Hooks/useCheckoutLead.js), so the
// follow-up email can mention what they were looking at (Alejo, 2026-10-21).
//
// Only the path is kept. The app's own screens are not "where they came from",
// so they never replace it.

const KEY = "checkoutFromPage";
const APP = /^\/(order|quote|account|office|make-payment|sign-in|create-account|forgot|verify|join-team|order-lookup|r|u)(\/|$)/;

const sameSite = (host) => host.replace(/^www\./, "") === window.location.hostname.replace(/^www\./, "");

// Called once on load (App.js).
export const captureEntryPage = () => {
  try {
    if (!document.referrer) {
      return;
    }
    const from = new URL(document.referrer);
    if (!sameSite(from.hostname) || APP.test(from.pathname)) {
      return;
    }
    window.sessionStorage.setItem(KEY, from.pathname.slice(0, 200));
  } catch (e) {
    // Blocked storage or an odd referrer: the lead just goes without it.
  }
};

export const storedEntryPage = () => {
  try {
    return window.sessionStorage.getItem(KEY) || "";
  } catch (e) {
    return "";
  }
};
